import { h, Component } from 'preact';
import style from './style.css';
import MuiInput from '../../../../components/material-ui/muiInput';
import { getNumericValue } from '../../../../utils/stringOperations';
import RequestButton from '../../../../components/requestButton';
import actionType from '../../../../actions/ntbAction/actionType';
import { tracker, UserActionType } from '../../../../tracking';
import Checkbox from 'preact-material-components/Checkbox';
import Formfield from 'preact-material-components/FormField';
import 'preact-material-components/Checkbox/style.css';
import { termsAndCondition } from '../../../../alias/commonRoutes';

class VerifyOtpScreen extends Component {
  state = {
    otp: '',
    resendCounter: 30,
    isTermsAccepted: false,
  };
  componentDidMount() {
    this.initTimer();
  }
  initTimer = () => {
    this.intervalId = setInterval(this.timer, 1000);
  };

  timer = () => {
    this.setState(
      ({ resendCounter }) => ({
        resendCounter: resendCounter - 1,
      }),
      () => {
        if (this.state.resendCounter === 0) {
          clearInterval(this.intervalId);
        }
      },
    );
  };
  resendOtp = () => {
    this.setState(
      {
        otp: '',
        resendCounter: 30,
      },
      this.initTimer,
    );
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'ap_resend_otp',
      this.pageKey,
      '',
    );
    const { channel, merchantId, mobile } = this.props || {};
    this.props.ntbAction(actionType.sendOTP, {
      mobile: mobile,
      merchantId,
      channel,
    });
  };

  resetTimer = () => {
    this.setState({
      resendOtpVisible: true,
    });
  };

  trackUserAction = (elementName, pageKey, other) => {
    tracker.trackUserInteraction(UserActionType.CLICK, elementName, pageKey, {
      ...other,
    });
  };

  onClickTermsAccepted = (isTermsAccepted) => {
    this.setState({ isTermsAccepted });
    isTermsAccepted &&
      tracker.trackUserInteraction(
        UserActionType.SELECT,
        'ap_accept_t&c',
        this.props.pageKey,
        '',
      );
  };

  render() {
    const {
      pageKey,
      mobile,
      ntbAction,
      channel,
      variant,
      utmSource,
      utmMedium,
      campaignId,
      utmContent,
      utmTerm,
      samePageOnOtpSuccess,
      urls,
      variation,
      merchantId,
    } = this.props || {};
    const { isTermsAccepted, otp, resendCounter } = this.state;
    return (
      <div className={style.otpSection}>
        <div className='font20 text-center bold-text text80'>
          Enter OTP to continue
        </div>
        <div className={`font14 ${style.enterOtpHeader}`}>
          <span className='text80'>Enter OTP sent on</span>{' '}
          <span className='bold-text'>{mobile}</span>
        </div>
        <div className={style.otpVerifyContainer}>
          <div>
            <MuiInput
              inputID='otp'
              inputPlaceholder='Enter 5 Digit OTP'
              pageKey={pageKey}
              maxLength={5}
              minLength={5}
              inputValue={otp}
              inputType='tel'
              className={style.otpInputBox}
              onChange={(e) => {
                const otp = getNumericValue(e.target.value);
                this.setState({ otp });
              }}
              elementName='ap_enter_otp'
            />
            <div style={{ textAlign: 'right', margin: 8 }}>
              {resendCounter > 0 ? (
                <div className='font12 primary-color bold-text'>
                  {resendCounter} sec
                </div>
              ) : (
                <div>
                  <span
                    className='font12 linkColor bold-text cursorPointer'
                    onClick={this.resendOtp}>
                    Resend OTP
                  </span>
                </div>
              )}
            </div>
          </div>
          <Formfield className={`blackCheckBox ${style.termsContainer}`}>
            <Checkbox
              id='verify-mobile-number-terms-and-condition-checkbox'
              checked={isTermsAccepted}
              onClick={() => {
                this.onClickTermsAccepted(!isTermsAccepted);
              }}
            />
            <label
              className='font12'
              id='verify-mobile-number-terms-and-condition-label'>
              <span className='text60'>I agree to</span>
              <span
                className={'text100 bold-text cursorPointer'}
                onClick={() => {
                  this.trackUserAction &&
                    this.trackUserAction(
                      UserActionType.SELECT,
                      'ap_view_t&c',
                      pageKey,
                      {},
                    );
                  window.open(termsAndCondition.path);
                }}>
                {' '}
                InstaCred’s Terms & Conditions
              </span>
            </label>
          </Formfield>
          <div className={style.otpVerifyBox}>
            <RequestButton
              buttonDisabled={this.state.otp.length !== 5 || !isTermsAccepted}
              buttonId='eligibility-button'
              loadingMsg='Verifying...'
              pageKey={pageKey}
              buttonWrapperClass={style.otpSubmitButton}
              elementName='ap_verify_otp'
              buttonText='Verify'
              buttonOnClick={() => {
                ntbAction(actionType.verifyOTP, {
                  mobile: mobile,
                  otp: otp,
                  channel,
                  samePage: samePageOnOtpSuccess,
                  urls: urls,
                  variant,
                  utmSource,
                  utmMedium,
                  campaignId,
                  utmContent,
                  utmTerm,
                  variation,
                  merchantId,
                });
              }}
              requestStatus={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default VerifyOtpScreen;



// WEBPACK FOOTER //
// ./routes/program-landing-page/components/overlayScreens/verifyOtpScreen.js